import { render } from "./App.vue?vue&type=template&id=c1dcce5a"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "@/assets/main.css?vue&type=style&index=0&lang=css&external"
import "./App.vue?vue&type=style&index=1&id=c1dcce5a&lang=scss"

import exportComponent from "../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__